<div class="element-wrapper" [ngStyle]="wrapperStyles">
  @if (labelEnabled) {
    <blaze-element-header
      [color]="props?.style?.title?.text?.color1"
      [fontFamily]="props?.style?.titleBlock?.fontFamily"
      [fontSize]="props?.style?.titleBlock?.fontSize"
      [fontStyle]="props?.style?.titleBlock?.fontStyle"
      [fontWeight]="props?.style?.titleBlock?.fontWeight"
      [horizontalAlign]="props?.content?.title?.align"
      [icon]="props?.content?.title?.icon"
      [iconColor]="props?.content?.title?.iconColor?.color1"
      [iconPosition]="props?.content?.title?.iconPosition"
      [iconSize]="props?.style?.titleBlock?.iconSize"
      class="mb-16"
    >
      {{ labelText }}
    </blaze-element-header>
  }
  @let context =
    {
      steps: (steps$$ | async) ?? [],
      selectedSlotIndex: (selectedSlotIndex$$ | async) ?? 0,
      absoluteSelectedSlotIndex: (absoluteSelectedSlotIndex$$ | async) ?? 0,
      confirmation: (confirmation$$ | async),
      emptyQuestionnaireHint: emptyQuestionnaireHint,
    };
  <div class="box" [class]="['placement-' + placement]">
    @if (!context.confirmation) {
      <div
        class="steps"
        [class]="['style-' + stepperStyle, 'align-' + align]"
        [class.short]="context.steps.length <= 1"
        [class.no-numbers]="!showStepNumbers"
      >
        @for (step of context.steps; track step; let i = $index) {
          @if (i > 0) {
            <div class="spacer"></div>
          }
          <div
            class="step"
            data-cy="Wizard:step"
            [class.complete]="i < context.selectedSlotIndex"
            [class.active]="i === context.selectedSlotIndex"
            [class.distant]="!isInEditor && i > context.selectedSlotIndex + 1"
            [class.stepHidden]="!step.show"
            blazeClickable
            (click)="selectStep(i)"
          >
            <div class="number">{{ i + 1 }}</div>
            <div class="label">{{ step.label }}</div>
            <div class="numberedLabel">{{ numberedStepLabel(i, step.label) }}</div>
            <mat-icon class="check" svgIcon="icon_check_16" />
          </div>
        }
        @if (stepperStyle === 'bar' && progressPercent.enabled) {
          <div class="percent" [class.percent-left]="progressPercent.position === 'left'">
            {{ getProgressPercent(context.selectedSlotIndex, context.steps.length) }}%
          </div>
        }
      </div>
    }
    <div class="currentStep" [class]="['style-' + stepperStyle, 'align-' + align]">
      <div class="numberedLabel">
        {{ numberedSelectedStepLabel(context.selectedSlotIndex, context.steps) }}
      </div>
    </div>

    <div class="content" [ngStyle]="contentStyles()">
      @if (slots?.slotIds?.length === 0 || context.emptyQuestionnaireHint) {
        <div class="slot">
          <div class="hint-generate">
            <span class="description">{{
              context.emptyQuestionnaireHint ?? (noSlotsMessage$ | async)
            }}</span>
          </div>
        </div>
      }
      @for (slotId of slots?.slotIds; track slotId; let i = $index) {
        <div
          class="slot"
          data-cy="Wizard:slot"
          [class.hidden]="
            context.confirmation ||
            context.emptyQuestionnaireHint ||
            i !== context.absoluteSelectedSlotIndex
          "
        >
          <div [blazeSlotNode]="slots?.slotNodesData?.[slotId]" class="h-full">
            <ng-container
              *ngTemplateOutlet="slots?.templates?.[slotId] || null; context: slotElementContext"
            />
          </div>
          @if (emptySlotMessage$ | async; as emptyMessage) {
            <div class="hint-generate">
              <span class="description">{{ emptyMessage }}</span>
            </div>
          }
        </div>
      }

      @if (!context.confirmation) {
        <div class="buttons">
          <div class="left">
            <button
              class="button"
              [class.hidden]="!canSaveDraft()"
              blazeClickable
              (click)="saveDraft()"
            >
              Save Draft
            </button>
          </div>
          <div class="right">
            @if (context.selectedSlotIndex > 0) {
              <button class="button" blazeClickable (click)="back()">Back</button>
            }
            @if (context.selectedSlotIndex < context.steps.length - 1) {
              <button class="button primary" data-cy="Wizard:next" blazeClickable (click)="next()">
                Next
              </button>
            }
            @if (context.selectedSlotIndex === context.steps.length - 1) {
              <button
                class="button primary"
                data-cy="Wizard:submit"
                blazeClickable
                (click)="submit()"
              >
                Submit
              </button>
            }
          </div>
        </div>
      }

      @if (context.confirmation && !context.emptyQuestionnaireHint) {
        <div class="confirmation">
          @if (context.confirmation.image) {
            <img [src]="context.confirmation.image" />
          }
          <div class="text">
            <div class="title">{{ context.confirmation.title }}</div>
            <div class="message">{{ context.confirmation.message }}</div>
            @if (context.confirmation.buttonLabel) {
              <div class="buttons !p-0">
                <button class="button primary continue" (click)="redirect()">
                  {{ context.confirmation.buttonLabel }}
                </button>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
</div>
